import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22layout.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../public/fonts/nacelle-regular.woff2%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22../public/fonts/nacelle-italic.woff2%22,%22weight%22:%22400%22,%22style%22:%22italic%22},{%22path%22:%22../public/fonts/nacelle-semibold.woff2%22,%22weight%22:%22600%22,%22style%22:%22normal%22},{%22path%22:%22../public/fonts/nacelle-semibolditalic.woff2%22,%22weight%22:%22600%22,%22style%22:%22italic%22}],%22variable%22:%22--font-nacelle%22,%22display%22:%22swap%22}],%22variableName%22:%22nacelle%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'nacelle', 'nacelle Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
